const { assign } = Object;
const { toc, fromRoute, toRoute } = require("../toc");
const search = require("./search").default;

module.exports = {
    namespaced: true,

    getters: {
        current(state, getters, { route }) {
            return fromRoute(route);
        },

        prev(state, { current }) {
            if (!current) {
                return null;
            }
            const { section, id } = current;
            let prev = undefined;

            if (section === "search") {
                for(const r of search.state.results) {
                    if (r.id === id) {
                        prev = r.prev;
                        break;
                    }
                }
            } else if (section === "watchlist") {
                // no op
            } else {
                prev = toc.prev(section, id);
            }

            if (!prev) {
                return null;
            }

            return assign(
                { section, route: toRoute({ component: "transcript", section, id: prev.id }) },
                prev
            );
        },

        next(state, { current }) {
            if (!current) {
                return null;
            }
            const { section, id } = current;

            let next = undefined;

            if (section === "search") {
                for(const r of search.state.results) {
                    if (r.id === id) {
                        next = r.next;
                        break;
                    }
                }
            } else if (section === "watchlist") {
                // no op
            } else {
                next = toc.next(section, id);
            }

            if (!next) {
                return null;
            }
            return assign(
                { section, route: toRoute({ component: "transcript", section, id: next.id }) },
                next
            );
        }
    }
};